// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddAuthorizedUser_SaveHomeownerMutationVariables = Types.Exact<{
  input: Types.SaveHomeownerInput;
}>;


export type AddAuthorizedUser_SaveHomeownerMutation = { __typename?: 'Mutation', saveHomeowner: { __typename?: 'SaveHomeownerResult', homeowner: { __typename?: 'Homeowner', id: string } } };


export const AddAuthorizedUser_SaveHomeownerDocument = gql`
    mutation AddAuthorizedUser_SaveHomeowner($input: SaveHomeownerInput!) {
  saveHomeowner(input: $input) {
    homeowner {
      id
    }
  }
}
    `;
export type AddAuthorizedUser_SaveHomeownerMutationFn = Apollo.MutationFunction<AddAuthorizedUser_SaveHomeownerMutation, AddAuthorizedUser_SaveHomeownerMutationVariables>;

/**
 * __useAddAuthorizedUser_SaveHomeownerMutation__
 *
 * To run a mutation, you first call `useAddAuthorizedUser_SaveHomeownerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAuthorizedUser_SaveHomeownerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAuthorizedUserSaveHomeownerMutation, { data, loading, error }] = useAddAuthorizedUser_SaveHomeownerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAuthorizedUser_SaveHomeownerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAuthorizedUser_SaveHomeownerMutation, AddAuthorizedUser_SaveHomeownerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddAuthorizedUser_SaveHomeownerMutation, AddAuthorizedUser_SaveHomeownerMutationVariables>(AddAuthorizedUser_SaveHomeownerDocument, options);
      }
export type AddAuthorizedUser_SaveHomeownerMutationHookResult = ReturnType<typeof useAddAuthorizedUser_SaveHomeownerMutation>;
export type AddAuthorizedUser_SaveHomeownerMutationResult = Apollo.MutationResult<AddAuthorizedUser_SaveHomeownerMutation>;
export type AddAuthorizedUser_SaveHomeownerMutationOptions = Apollo.BaseMutationOptions<AddAuthorizedUser_SaveHomeownerMutation, AddAuthorizedUser_SaveHomeownerMutationVariables>;